export const featuredPortfolio = [{
        id: 1,
        title: "E-commerce",
        img: "assets/boutique.PNG",
        link: "https://randyaajr-shop.herokuapp.com/",
    },
    {
        id: 2,
        title: "STACKEM",
        img: "assets/stackem.PNG",
        link: "https://randyaajr.github.io/javascript_stack-em-game/",
    },
    {
        id: 3,
        title: "Pizzeria Defina",
        img: "assets/defina.PNG",
        link: "http://www.pizzeriadefina.com/",
    },
    {
        id: 4,
        title: "Task Manager",
        img: "assets/task-manager0.PNG",
        link: "https://task-manager-randy.herokuapp.com/get_tasks",
    },
    {
        id: 5,
        title: "Portfolio V1",
        img: "assets/resume0.PNG",
        link: "https://randyaajr.github.io/resume-webpage/",
    },
    {
        id: 6,
        title: "Portfolio V2",
        img: "assets/portfolio-old.PNG",
        link: "https://randyaajr.github.io/portfolio-randy/",
    },
    {
        id: 7,
        title: "InfoFlix",
        img: "assets/infoflix0.PNG",
        link: "https://randyaajr.github.io/InfoFlix_Milestone-2/",
    },
    {
        id: 8,
        title: "Homies",
        img: "assets/homies.PNG",
        link: "https://60a6b2828fcc5b00e5bbb048--affectionate-almeida-fddb2b.netlify.app/",
    },
    {
        id: 9,
        title: "Tours",
        img: "assets/tours.PNG",
        link: "https://randyaajr.github.io/sass-project_tours-travel-agency/",
    },
];

export const webPortfolio = [{
        id: 1,
        title: "E-commerce",
        img: "assets/boutique.PNG",
        link: "https://randyaajr-shop.herokuapp.com/",
    },
    {
        id: 2,
        title: "Task Manager",
        img: "assets/task-manager0.PNG",
        link: "https://task-manager-randy.herokuapp.com/get_tasks",
    },
    {
        id: 3,
        title: "Tours",
        img: "assets/tours.PNG",
        link: "https://randyaajr.github.io/sass-project_tours-travel-agency/",
    },
    {
        id: 4,
        title: "Portfolio V1",
        img: "assets/resume0.PNG",
        link: "https://randyaajr.github.io/resume-webpage/",
    },
    {
        id: 5,
        title: "Portfolio V2",
        img: "assets/portfolio-old.PNG",
        link: "https://randyaajr.github.io/portfolio-randy/",
    },
    {
        id: 6,
        title: "InfoFlix",
        img: "assets/infoflix0.PNG",
        link: "https://randyaajr.github.io/InfoFlix_Milestone-2/",
    },
    {
        id: 7,
        title: "Meal Maid",
        img: "assets/meal-maid0.PNG",
        link: "https://randyaajr.github.io/Meal-Maid_Milestone-1/",
    },
    {
        id: 8,
        title: "Whisky Drop",
        img: "assets/whiskydrop0.PNG",
        link: "https://randyaajr.github.io/bootstrap-whiskeydrop-first-repo/",
    },
    {
        id: 9,
        title: "Todo-List",
        img: "assets/todo-app0.PNG",
        link: "https://randyaajr.github.io/Todo-list/",
    },
    {
        id: 10,
        title: "Homies",
        img: "assets/homies.PNG",
        link: "https://60a6b2828fcc5b00e5bbb048--affectionate-almeida-fddb2b.netlify.app/",
    },
    {
        id: 11,
        title: "Love Runnings",
        img: "assets/loverunnings0.PNG",
        link: "https://randyaajr.github.io/Love-Runnings/",
    },
];

export const clientPortfolio = [{
    id: 1,
    title: "Pizzeria Defina",
    img: "assets/defina.PNG",
    link: "http://www.pizzeriadefina.com/",
}, ];

export const mobilePortfolio = [];

export const gamesPortfolio = [{
        id: 1,
        title: "Space Dots",
        img: "assets/sdg.PNG",
        link: "https://codepen.io/randyaajr/full/xxEzrKr",
    },
    {
        id: 2,
        title: "STACKEM",
        img: "assets/stackem.PNG",
        link: "https://randyaajr.github.io/javascript_stack-em-game/",
    },
    {
        id: 3,
        title: "Archery",
        img: "assets/archery.PNG",
        link: "https://codepen.io/randyaajr/full/LYRrjRv",
    },
    {
        id: 4,
        title: "Tetris",
        img: "assets/tetris.PNG",
        link: "https://codepen.io/randyaajr/full/abmaKXb",
    },
    {
        id: 5,
        title: "Space Invaders",
        img: "assets/sp-inv.PNG",
        link: "https://codepen.io/randyaajr/full/ExgeReq",
    },
    {
        id: 6,
        title: "Boxie",
        img: "assets/Boxie-game0.PNG",
        link: "https://randyaajr.github.io/Javascript-box-game/",
    },
];

export const instrumentalsPortfolio = [{
        id: 1,
        title: "Childish Games - Trap Beat",
        img: "assets/mpChildish-Games.PNG",
        link: "https://bsta.rs/0f9a485e",
    },
    {
        id: 2,
        title: "Gun Smoke - Trap Beat",
        img: "assets/mpGun-Smoke.PNG",
        link: "https://bsta.rs/9f7ee7e8",
    },
    {
        id: 3,
        title: "Astroplane - Trap Beat",
        img: "assets/mpAstroplane.PNG",
        link: "https://bsta.rs/d58213c5",
    },
    {
        id: 4,
        title: "Pathogen - Trap Beat",
        img: "assets/mpPathogen.PNG",
        link: "https://bsta.rs/ab9ca9d",
    },
    {
        id: 5,
        title: "Shattered - Trap Beat",
        img: "assets/mpShattered.PNG",
        link: "https://bsta.rs/89b12f8",
    },
    {
        id: 6,
        title: "Ya Rab - Trap Beat",
        img: "assets/mpYa-Rab.PNG",
        link: "https://bsta.rs/0f9a485e",
    },
    {
        id: 7,
        title: "Anxiety - Trap Beat",
        img: "assets/mpAnxiety.PNG",
        link: "https://bsta.rs/8147bbe",
    },
    {
        id: 8,
        title: "Wallahi - Trap Beat",
        img: "assets/mpWallahi.PNG",
        link: "https://bsta.rs/a6b6a13",
    },
];